import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

// ShopFront_List
export const getShopFrontList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      apiendpoints.MANAGE_SHOPFRONT_LIST_API
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// ShopFront_By_Id
export const getShopFrontById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_SHOPFRONT_BY_ID_API}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// ShopFront_Update
export const AddupdateShopFront = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true, true));
    const response = await axioClient.post(
      apiendpoints.MANAGE_SHOPFRONT_ADD_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// ShopFront_Delete
export const DeleteShopFront = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      `${apiendpoints.MANAGE_SHOPFRONT_DELETE_API}?productId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getTraderShopFrontList = async (traderid) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_TRADER_SHOPFRONT}?id=${traderid}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
